<template>
    <section>
        <form @submit.prevent="confirm">            
            <h2 class="title pink mt-2">WELCOME</h2>
            <hr />
            <div class="row">
                <div class="col">
                    <p><b>Welcome to Insurance for Models, the assistance program dedicated to the Modeling world!</b></p>
                </div>
            </div>
            <div class="row">
                <div class="col">

                    <p>Now you have at your disposal services and insurance guarantees that can be activated directly online through this web-app, like a multilingual assistance network active 24 hours a day and 365 days a year from which you can request medical support and an urgent health intervention.</p>

                    <p>
                        The assistance program also protects you in case of injury and illness (also from pandemic risk) by offering health care and reimbursement of medical expenses.<br/>
                        It also provides compensation in case of temporary disability and supports in case of travel inconveniences and covers third party liability. 
                    </p>
                </div>
            </div>
            <hr />
            <div class="row">
                <div class="col">
                    <p>
                        <b>The terms and conditions of INS4Models policy are readable and downloadable <download what="terms_and_conditions"/></b>
                    </p>
                    <div class="form-group">
                        <b-form-checkbox
                            id="cga"
                            v-model="form.cga"
                            name="cga"
                            value="accepted"
                            unchecked-value="not_accepted"
                            :class="{ 'is-invalid': $v.form.cga.$error }"
                            :state="validateState('cga')"
                            >
                            Please confirm that you have read the terms and conditions and/or acknowledge that they are available to you.
                        </b-form-checkbox>
                        <div class="invalid-feedback" v-if="!$v.form.cga.required">* you need to accept to continue</div>
                    </div>
                </div>
            </div>
            <div class="row-btn">
                <button type="submit" class="btn btn-primary">Next</button>
            </div>											
        </form>
    </section>                
</template>

<script>
//import { required } from 'vuelidate/lib/validators'

export default {
    data: function () {
        return {
            form: {
                cga: "not_accepted"
            }            
        }
    },
    validations: {
        form: {
            cga: {
                checked: value => value == 'accepted',
            },
        }
    },
    created() {
        this.$emit('set-style', '');
        this.$emit('set-small-logo');
        this.$emit('set-bg-classes', 'bg');
        this.$emit('set-container-classes', 'col-12 col-md-8');
    }, 
    computed: {
        fullName(){
            return this.$store.state.userInfo.name
        }
    },
    methods: {
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty && $error==true ? !$error : null;
        },
        confirm: function(){

            this.$v.$touch()
            if (this.$v.$invalid) {
                return false;
            }

            this.$store.dispatch('acceptPrivacy', { ...this.form })
                .then(() => {
                    this.$router.push('/');
                })
                .catch(() => {
                    //console.log(err);
                });
        }
    }
}
</script>